import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromIssueTracker from '../../reducers/issue-tracker/issue-tracker.reducer';

export const selectIssueTrackerState = createFeatureSelector<fromIssueTracker.State>(
  fromIssueTracker.issueTrackerFeatureKey
);

export const selectTickets = createSelector(
  selectIssueTrackerState,
  (state) => state.tickets
);

export const selectTicketCategories = createSelector(
  selectIssueTrackerState,
  (state) => state.ticketCategories
);

export const selectTicketStatuses = createSelector(
  selectIssueTrackerState,
  (state) => state.ticketStatuses
);

export const selectTicketLoading = createSelector(
  selectIssueTrackerState,
  (state) => state.loading
);

export const selectTicketCategoriesLoading = createSelector(
  selectIssueTrackerState,
  (state) => state.categoriesLoading
);

export const selectTicketStatusesLoading = createSelector(
  selectIssueTrackerState,
  (state) => state.statusesLoading
);

export const selectTicketError = createSelector(
  selectIssueTrackerState,
  (state) => state.error
);

export const selectOpenTicketsCount = createSelector(
  selectTickets,
  (tickets) => tickets.filter(ticket =>
    !['closed', 'resolved'].includes(ticket.ticketStatusName?.toLowerCase() || '')
  ).length
);

export const selectTotalTicketsCount = createSelector(
  selectTickets,
  (tickets) => tickets.length
);

export const selectClosedTicketsCount = createSelector(
  selectTickets,
  (tickets) => tickets.filter(ticket => 
    ['closed', 'resolved'].includes(ticket.ticketStatusName?.toLowerCase() || '')
  ).length
);

export const selectDownloadingAttachment = createSelector(
  selectIssueTrackerState,
  (state) => state.downloadingAttachment
);

export const selectPreviewingAttachment = createSelector(
  selectIssueTrackerState,
  (state) => state.previewingAttachment
);

export const selectTicketCategoryById = (categoryId: number) => createSelector(
  selectTicketCategories,
  (categories) => categories.find(category => category.id === categoryId)
);

export const selectTicketStatusById = (statusId: number) => createSelector(
  selectTicketStatuses,
  (statuses) => statuses.find(status => status.id === statusId)
);